import datasetParser from "@Dataset/datasetParser";
import {CompanyCard} from "@Pages/stationToStation/features/companyCard/components/CompanyCard";

export const CompanyCards = ({index}: {index?: number}) => {
    const parsedData = datasetParser({id: 'company-list'})

    return (
        <>
            {parsedData?.companiesOnRoute?.map((_: any, index: number) => (
                <CompanyCard index={index} />
            ))}
        </>
    )
}